<div class="informate_select_wrapper" [formGroup]="form">
    <mat-label class="mat-label-general" [ngbTooltip]="pressure_class_toolTip" placement="right" container="body" tooltipClass="custom-tooltip">
        <!-- Pressure Class -->
        {{ 'STANDARD_FLANGE_PAGE.LABELS.CALC_INPUT.PRESSURE_CLASS' | transloco }}
    </mat-label>
    <!--tool-tip template start-->
    <ng-template #pressure_class_toolTip>
        <p>
            {{ 'TOOLTIP.INFORMATE_CALC_LABELS.PRESSURE_CLASS' | transloco }}
        </p>
    </ng-template>
    <!--tool-tip template end-->
    <mat-select
        formControlName="pressureClass"
        name="pressure_class"
        class="mat-select-general input-form-class"
        [class.spinner]="loading"
        [class.select-disable]="enable"
    >
        <mat-option class="option-list" *ngFor="let pcl of pressureClassList" [value]="pcl.pressureClassId">{{ pcl.name }}</mat-option>
    </mat-select>
</div>
